import React from "react";
import { Tag } from "antd";
import { motion } from "framer-motion";

interface AlertFlagBadgeProps {
  flag: "🔴" | "🟠" | "🟢" | "⚫";
  text?: string;
  delay?: number;
}

export const AlertFlagBadge: React.FC<AlertFlagBadgeProps> = ({
  flag,
  text,
  delay = 0,
}) => {
  const getColorAndStatus = () => {
    switch (flag) {
      case "🔴":
        return { color: "error", label: text || "Critical" };
      case "🟠":
        return { color: "warning", label: text || "Moderate" };
      case "🟢":
        return { color: "success", label: text || "Normal" };
      case "⚫":
        return { color: "default", label: text || "Finance Risk" };
      default:
        return { color: "default", label: text || "Unknown" };
    }
  };

  const { color, label } = getColorAndStatus();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay }}
      style={{ display: "inline-block" }}
    >
      <Tag color={color as any} style={{ fontSize: 12, fontWeight: 600 }}>
        {flag} {label}
      </Tag>
    </motion.div>
  );
};
